module.exports = __webpack_public_path__ + "static/media/chat.8c4d911e.svg";